import type { ExcelGridColumn } from "../../shared/excel-grid/models/excel-grid.models";
import type { AdminPnlFilters } from "../models/admin-pnl.models";

export const ADMIN_PNL_INITIAL_FILTERS: AdminPnlFilters = { search: "", reviewerEmail: "" };

export const ADMIN_PNL_COLUMNS: ExcelGridColumn[] = [
  { key: "CURRENT_NAME", label: "Current vessel", minWidth: 180 },
  { key: "SUMMARY_NAME", label: "Saved summary name", minWidth: 180 },
  { key: "APPROVAL_NAME", label: "Saved approval name", minWidth: 180 },
  { key: "TC_CODE", label: "Contract", minWidth: 140 },
  { key: "VOYAGE_NO", label: "Voyage", minWidth: 90 },
  { key: "VESSEL_CODE", label: "Vessel code", minWidth: 120 },
  { key: "IMO_NUMBER", label: "IMO", minWidth: 110 },
  { key: "STATUS", label: "Latest status", minWidth: 130 },
  { key: "SUBMITTED_BY", label: "Submitter", minWidth: 260 },
  { key: "SUBMITTED_AT", label: "Submitted at", minWidth: 230 },
  { key: "SUMMARY_AT", label: "Summary loaded at", minWidth: 230 },
  { key: "REVIEW_RESULT", label: "Review visibility", minWidth: 170 },
  { key: "DIAGNOSIS", label: "Diagnosis", minWidth: 330 },
].map((column) => ({ ...column, editable: false, sortable: true, filterable: true }));
